$(document).ready(function (){

	if (srzsd){
		srzsd.ersetzeAdressen();
	}

});

var srzsd = srzsd || {};

srzsd.ersetzeAdressen = function (kontext){

	if (kontext == null){
		kontext = document;
	}

	var getEmail = function(bezeichnung){

		bezeichnung = bezeichnung.replace(/ ?\(at\) ?/, "@");
		bezeichnung = bezeichnung.replace(/ ?\(punkt\) ?/g, ".");
		bezeichnung = bezeichnung.replace(/ ?\(dot\) ?/g, ".");

		var adresse = bezeichnung;

		if (adresse.search(/\[.*\]/) != -1){

			ergebnis = adresse.match(/(.*?) ?\[(.*)\]/);

			adresse = (ergebnis[2])?ergebnis[2]:adresse;
			bezeichnung = (ergebnis[1])?ergebnis[1]:adresse;

		}

		return new Array(bezeichnung, adresse);
	}


	$(".srzsd-epost", kontext).each(function(){

		if ($("> a", this).length == 0){

			var email = getEmail($(this).html());

			var betreff = (this.title !== "")?"?subject=" + encodeURI(this.title):"";

			$(this).html('<a href="mailto:' + email[1] + betreff + '">' + email[0] + '</a>');

		}

	});

	$(".srzsd-vcard", kontext).each(function(){

		if (this.title){

			var link = this.title + ".vcf";
			$(this).removeAttr("title");

			$(this).wrapAll('<a href="' + link + '"/>');

		}

	});

}
